module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_external_link_gold-7c8f0196c4145beb2638bbccd4526111.svg";